import { cn } from '@/lib/utils';
import type { ChannelStatusLabel } from '../../utils/contact-subscription-status';
import {
  getChannelStatusDotClassName,
  getChannelStatusPillClassName,
} from '../../utils/contact-subscription-status';

type ContactSubscriptionStatusPillProps = {
  status: ChannelStatusLabel;
  className?: string;
};

export const ContactSubscriptionStatusPill = ({
  status,
  className,
}: ContactSubscriptionStatusPillProps) => (
  <span
    className={cn(
      'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
      getChannelStatusPillClassName(status),
      className
    )}
  >
    <span className={cn('size-1.5 shrink-0 rounded-full', getChannelStatusDotClassName(status))} />
    {status}
  </span>
);
